import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '@app/services';
import { DirectivesModule, PipesModule, SharedModule } from '@app/shared';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { Subscription } from 'rxjs';
import { AuthService, IReset } from '..';
import { AuthShellComponent } from '../shell';
import { FormGroupInterface, FormGroupValuesInterface } from './reset.interface';

@Component({
  imports: [SharedModule, DirectivesModule, PipesModule, AuthShellComponent],
  selector: 'app-reset',
  templateUrl: './reset.component.html',
})
export class ResetComponent extends BaseService implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  params$: Subscription;
  id: string;
  token: string;
  formReset: FormGroup;

  ngOnInit(): void {
    this.createForm();
    this.params$ = this.route.queryParams.subscribe(this.onParamsChange.bind(this));
  }

  ngOnDestroy(): void {
    this.params$.unsubscribe();
  }

  onParamsChange(params: { id?: string; token?: string }): void {
    this.id = params.id ?? undefined;
    this.token = params.token ?? undefined;
  }

  createForm(): void {
    this.formReset = new FormGroup<FormGroupInterface>({
      password: new FormControl('', [RxwebValidators.required(), RxwebValidators.minLength({ value: 5 })]),
      confirmPassword: new FormControl('', [RxwebValidators.required(), RxwebValidators.compare({ fieldName: 'password' })]),
    });
  }

  reset(): void {
    const formValues: FormGroupValuesInterface = this.formReset.getRawValue();
    const newPassword: string = formValues.password;
    this._spin.start();
    const params: IReset = {
      id: this.id,
      token: this.token,
      password: newPassword,
    };
    this.authService
      .reset(params)
      .then(() => {
        this._toast.success({ message: 'Senha alterada com sucesso!' });
        void this.router.navigateByUrl('/signin');
      })
      .catch((e: Error) => {
        this._toast.error({ message: e.message });
      })
      .finally(() => {
        this._spin.stop();
      });
  }
}
